import { gql } from '@apollo/client';

import { CODE_FRAGMENT, IDENTIFIER_FRAGMENT } from '../../shared/fragments';

export const FETCH_ALL_DOCUMENTS_QUERY = gql`
  query fetchAllDocumentReferences(
    $sourceUrl: String
    $count: String
    $offset: Int
    $dateFilter: Float
    $statusFilter: String
    $searchFilter: String
  ) {
    fetchAllDocumentReferences(
      sourceUrl: $sourceUrl
      count: $count
      offset: $offset
      dateFilter: $dateFilter
      statusFilter: $statusFilter
      searchFilter: $searchFilter
    ) {
      documentReferenceList
      count
    }
  }
`;
